import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({providedIn: 'root'})
export class PrivacyPolicyGuard  {
  constructor(
    private router: Router
  ) { }

  canActivate() {
    if (environment.design["legalAppName"]) { return true }
    else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}